const API_BASE_URL = "https://api.easyrpgnotes.com";
export default API_BASE_URL;
